"use client"

import { useEffect } from "react"

/**
 * Keeps --scrollbar-width in sync for custom scroll locks (e.g. lightbox).
 * Also sets --site-chrome-end-gap when body is scroll-locked but does not expose
 * --removed-body-scroll-bar-size (Clerk modal + some scroll-lock stacks).
 */
export function ScrollbarWidthVars() {
  useEffect(() => {
    const root = document.documentElement
    let lastNonZeroScrollbarPx = 0

    const syncChromeEndGap = () => {
      requestAnimationFrame(() => {
        const body = document.body
        const locked = body.hasAttribute("data-scroll-locked")
        const fromBody = getComputedStyle(body)
          .getPropertyValue("--removed-body-scroll-bar-size")
          .trim()
        const hasBodyVar = Boolean(fromBody && fromBody !== "0px")

        if (!locked) {
          root.style.setProperty("--site-chrome-end-gap", "0px")
          return
        }
        if (hasBodyVar) {
          root.style.setProperty("--site-chrome-end-gap", "0px")
          return
        }
        root.style.setProperty(
          "--site-chrome-end-gap",
          `${lastNonZeroScrollbarPx}px`,
        )
      })
    }

    const update = () => {
      const w = Math.max(0, window.innerWidth - root.clientWidth)
      if (w > 0) lastNonZeroScrollbarPx = w
      root.style.setProperty("--scrollbar-width", `${w}px`)
      syncChromeEndGap()
    }

    const mo = new MutationObserver(syncChromeEndGap)
    mo.observe(document.body, {
      attributes: true,
      attributeFilter: ["data-scroll-locked", "style", "class"],
    })

    update()
    window.addEventListener("resize", update)
    return () => {
      window.removeEventListener("resize", update)
      mo.disconnect()
    }
  }, [])
  return null
}
